import {styled} from "@reside/ui";
import {Layout, LayoutContent} from "../../atoms/admin-layout";
import {COLUMN_BOTTOM_INSET_PX} from "../../atoms/dashboard-table/Column";

export const FullWidthDashboardHeader = styled.div`
  // The header is positioned 'over' the grid to prevent dropdowns/popups from the grid to overflow on top of it
  background: ${({theme}) => theme.color.darkBlue5};
  z-index: 997;
  padding: 25px ${({theme}) => theme.space[7]}px 14px
    ${({theme}) => theme.space[7]}px;

  @media (max-width: 1170px) {
    padding-left: 15px;
    padding-right: 15px;
  }

  @media (max-width: 768px) {
    padding-left: 10px;
    padding-right: 10px;
  }

  @media (max-width: 460px) {
    padding-left: 7px;
    padding-right: 7px;
  }
`;
export const DashboardLayout = styled(Layout)`
  height: 100vh; /* definite height for Safari: min-height alone isn't treated as definite in Safari's flex algo */
  min-height: 100vh;
  overflow: hidden; /* prevent body scroll on iOS; board scrolls internally */
`;
/**
 * Horizontal inset for dashboard main content. Tile view bleeds the board
 * outward by this amount so the scroll bar sits flush with the padded region
 * and `--dashboard-h-pad` stays in sync for `DashboardTileBleed`.
 */
export const FullWidthDashboardLayoutContent = styled(LayoutContent)`
  flex-grow: 1;
  min-height: 0; /* allow flex child to shrink so inner overflow scroll works like tile view */
  max-width: none;
  padding-top: 0 !important;
  padding-left: ${({theme}) => theme.space[7]}px;
  padding-right: ${({theme}) => theme.space[7]}px;
  --dashboard-h-pad: ${({theme}) => theme.space[7]}px;

  @media (max-width: 1170px) {
    padding-left: 15px;
    padding-right: 15px;
    --dashboard-h-pad: 15px;
  }

  @media (max-width: 768px) {
    padding-left: 10px;
    padding-right: 10px;
    --dashboard-h-pad: 10px;
  }

  @media (max-width: 460px) {
    padding-left: 7px;
    padding-right: 7px;
    --dashboard-h-pad: 7px;
  }
`;

/** Full-bleed tile board inside padded layout: scrollbar to content edge, centered columns use full width. */
export const DashboardTileBleed = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  margin-left: calc(-1 * var(--dashboard-h-pad));
  margin-right: calc(-1 * var(--dashboard-h-pad));
  width: calc(100% + 2 * var(--dashboard-h-pad));
`;

/** Caps the Kanban board at 1440px and centers it when the viewport is wider. */
export const DashboardTileBoardMax = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1920px;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
`;

export const ListTileViewSwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  i {
    padding: 5px 3px;
    cursor: pointer;
    background-color: ${({theme}) => theme.color.darkBlue100}10;
    border-radius: 4px;
    transition: background-color 0.1s ease-in-out;

    &:hover {
      background-color: ${({theme}) => theme.color.darkBlue100}30;
    }

    &.active-view {
      background-color: ${({theme}) => theme.color.darkBlue100}30;
    }
  }
`;

export const LoadMoreWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: fit-content;
  text-align: center;
  margin-top: ${({theme}) => theme.space[3]}px;
  padding-bottom: ${COLUMN_BOTTOM_INSET_PX}px;
`;
